import React, { useEffect, useState } from 'react';
import { apiGetCategory } from '@services/ManageDevices/DeviceServices';
import { Select } from 'antd';

const mapListToOptions = (data) => {
  return data?.map((item) => ({
    value: item.value,
    label: item.name,
    ...item
  }));
};

export const SelectRoute = ({ disabled = false, onChange, value }) => {
  const [options, setOptions] = useState([]);

  const handleChange = (value) => {
    onChange && onChange(value);
  };

  const fetchOptions = async (valueSearch) => {
    const response = await apiGetCategory({
      keyword: valueSearch === '' ? undefined : valueSearch,
      type: 'TUYEN'
    });
    setOptions([...mapListToOptions(response?.data?.data)]);
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  const selected = options.find(({ value: itemValue }) => value === itemValue);

  return (
    <Select
      style={{ width: '100%', height: '36px' }}
      className="w-full"
      cacheOptions
      isDisabled={disabled}
      options={options}
      placeholder="Chọn Mạng lưới"
      loadOptions={fetchOptions}
      value={selected}
      onChange={handleChange}
    />
  );
};
